/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobHandlerConfiguration {
    getFixupPrototypeFunction() { return BackgroundJobHandlerConfiguration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobHandlerConfiguration>): BackgroundJobHandlerConfiguration {
        let obj = Object.assign(new BackgroundJobHandlerConfiguration(), model);
        BackgroundJobHandlerConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobHandlerConfiguration>): BackgroundJobHandlerConfiguration {
        if (!model) return null;
        return BackgroundJobHandlerConfiguration.newInstance(<BackgroundJobHandlerConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobHandlerConfiguration) {
        if (!obj) return;

        models.BackgroundJobHandlerConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobHandlerConfiguration): boolean {
        Object.setPrototypeOf(obj, BackgroundJobHandlerConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.max_parallel_jobs === undefined) {
            this.max_parallel_jobs = 0;
        }
        if (this.max_processes === undefined) {
            this.max_processes = 0;
        }
        if (this.default_max_parallel_jobs === undefined) {
            this.default_max_parallel_jobs = 0;
        }
        if (this.default_max_processes === undefined) {
            this.default_max_processes = 0;
        }
        if (typeof this.override_expiration === "string") {
            this.override_expiration = new Date(<string><any>this.override_expiration);
        }
    }

    /**
     * Maximum number of concurrent jobs to process
     */
    max_parallel_jobs: number;

    /**
     * Maximum number of workers to run jobs
     */
    max_processes: number;

    /**
     * Default value for number of concurrent jobs to process
     */
    default_max_parallel_jobs: number;

    /**
     * Default value for number of workers to run jobs
     */
    default_max_processes: number;

    /**
     * Override defaults until expiration
     */
    override_expiration: Date;

}
